module.exports = __webpack_public_path__ + "img/signature.d0bb8bf2.png";